		<div id="navBar"> 
    		<ul class="nav">
    			<li id="logo">
    				<img src="assets/images/logo.png" alt="MTData">
				</li>
                <a [routerLink]="['/driver/home']" routerLinkActive #rlaHome="routerLinkActive">
                    <li [class.active]="rlaHome.isActive" >
                        <svg class="icon">
                            <use xlink:href="assets/iconography/symbol-defs.svg#icon-document"></use>
                        </svg>
                        <span>Work Diary</span>
                    </li>
				</a>
                <a [routerLink]="['/driver/compliance']" routerLinkActive #rlaCompliance="routerLinkActive">
                    <li [class.active]="rlaCompliance.isActive" >
                        <svg class="icon">
                            <use xlink:href="assets/iconography/symbol-defs.svg#icon-officer"></use>
                        </svg>
                        <span>Compliance</span>
                    </li>
				</a>
                <a [routerLink]="['/driver/transfer']" routerLinkActive #rlaTransfer="routerLinkActive">
                    <li [class.active]="rlaTransfer.isActive" >
                        <svg class="icon">
                            <use xlink:href="assets/iconography/symbol-defs.svg#icon-data-transfer"></use>
                        </svg>
                        <span>Transfer History</span>
                    </li>
                </a>				
    		</ul>
    		<div id="leftDragBar" class="dragBar"></div>
		</div>
		<div id="content">
			<header>
				<div id="toolBar">
					<div class="tools">
						<div class="toolGroup">
							<breadcrumb></breadcrumb>
						</div><!-- toolGroup -->
						<div class="toolGroup">
							<div id="profile" tabindex="0" class="expandableTool simple">
								<div class="tool">
									<svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-user"></use></svg>
								</div><!-- tool -->
								<div class="toolSelect rightAlign">
									<ul>
										<li>
										<p>Hello, <strong>{{name}}</strong></p>
										</li>
										<div class="lineBreak"></div>
										<a [routerLink]="['/driver/profile']">
											<li>
												<svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-user"></use></svg> View profile
											</li>
										</a>
										<a [routerLink]="['/driver/settings']">
											<li>
												<svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-data"></use></svg> Driver settings
											</li>
										</a>
										<!-- <a [routerLink]="['/driver/logs']">
											<li>
												<svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-download"></use></svg> Driver logs
											</li>
										</a> -->
										<!-- <a href="">
											<li>
												<svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-cog"></use></svg> User settings
											</li>
										</a> -->
										<a href="#/login">
											<li>
												<svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-exit"></use></svg> Log Out
											</li>
										</a>
									</ul>
								</div>
							</div>
							<div id="help" tabindex="0" class="expandableTool simple">
								<div class="tool">	
									<svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-maintenance"></use></svg>
								</div>
								<div class="toolSelect rightAlign">
									<ul>
										<li>
											<a [routerLink]="" (click)="showHelp()">
												<li>
													<svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-question"></use></svg> Help
												</li>
											</a>		
										</li>
										<div class="lineBreak"></div>
										<li>
												<a [routerLink]="" (click)="showAbout()">
												<li>
													<svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-information"></use></svg> About
												</li>
											</a>		
										</li>
									</ul>
								</div>
							</div>
							<div id="themes" tabindex="0" class="expandableTool simple">
								<div class="theme preview"></div>
								<div class="toolSelect">
									<ul id="themeChoices">
										<li>
											<div id="light" class="theme">
												<svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-tick"></use></svg>
											</div>
										</li>
										<li>
											<div id="dark" class="theme active">
												<svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-tick"></use></svg>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>
			
			<router-outlet></router-outlet>
		</div> 